import React from 'react'
import { WHAT_CAN_SELL, MANAGING_ARTWORKS_LINK } from '../../helpers/constants'
import type { SectionProps } from './Section'
import Section from './Section'

const Component = (props: SectionProps): React.ReactElement<React.ComponentProps<any>, any> => {
  const { currentSection, onToggle, section } = props
  return (
    <Section
      name={WHAT_CAN_SELL}
      title='What can I sell on Saatchi Art'
      {...{
        currentSection,
        onToggle,
        section,
      }}
    >
      <p>
        Saatchi Art provides a platform for artists to sell works in a variety of mediums,
        including: painting, collage, photography, drawing, sculpture, printmaking, mixed media,
        limited edition prints, installation, and open edition prints.{' '}
        <a data-type='link' target='_blank' rel='noopener noreferrer' href={MANAGING_ARTWORKS_LINK}>
          Learn More
        </a>
      </p>
    </Section>
  )
}

export default Component